import { ProductType } from '@generated/gql/graphql';

export const NO_BONUS = '£0';

export interface Tier {
  count: number;
  lockedLabel: string;
  unlockedLabel: string;
  amount: string;
}

export const TIER_SERVICES: ProductType[] = [
  ProductType.Energy,
  ProductType.Broadband,
  ProductType.Mobile,
  ProductType.Insurance,
];

export const TIERS: Tier[] = [
  {
    count: 2,
    lockedLabel: 'Unlock £50',
    unlockedLabel: '£50 unlocked',
    amount: '£50',
  },
  {
    count: 3,
    lockedLabel: 'Unlock £150',
    unlockedLabel: '£150 unlocked',
    amount: '£150',
  },
  {
    count: 4,
    lockedLabel: 'Unlock £250',
    unlockedLabel: '£250 unlocked',
    amount: '£250',
  },
];

export const getTierServices = (selectedServices: ProductType[]) =>
  selectedServices.filter((service) => TIER_SERVICES.includes(service));

export const hasCashbackCard = (selectedServices: ProductType[]) =>
  selectedServices.includes(ProductType.CashbackCard);

export const getVisibleTiers = (insuranceAvailable: boolean) =>
  insuranceAvailable ? TIERS : TIERS.slice(0, -1);

export const getBonusAmount = (serviceCount: number, visibleTiers: Tier[]) =>
  visibleTiers.reduce(
    (amount, tier) => (serviceCount >= tier.count ? tier.amount : amount),
    NO_BONUS
  );
